export const updateBasicDetailsRoutineInspection = (type, details) => ({
    type: type,
    //"UPDATE_BASIC_DETAILS_ROUTINE_INSPECTION",
    payload: details,
  });
  export const mandatoryFieldsBasicDetailsRoutineInspection = (type, details) => ({
    type: type,
    //"UPDATE_ROUTINE_INSPECTION_BASIC_DETAILS_MANDATORY_FIELDS",
    payload: details,
  });
  export const mandatoryFieldsAssesmentsRoutineInspection = (type, details) => ({
    type: "UPDATE_ROUTINE_INSPECTION_ASSESMENTS_MANDATORY_FIELDS",
    //"UPDATE_ROUTINE_INSPECTION_ASSESMENTS_MANDATORY_FIELDS",
    payload: details,
  });
  
  export const completionInfoMandatoryFieldsRoutineInspection = (type, details) => ({
    type: type,
    //"UPDATE_ROUTINE_INSPECTION_COMPLETION_INFO_MANDATORY_FIELDS",
    payload: details,
  });
  
  export const partReplacementDetailsRoutineInspection = (type, details) => ({
    type: "PART_REPLACEMENT_ROUTINE_INSPECTION",
    //"PART_REPLACEMENT_ROUTINE_INSPECTION"
    payload: details,
  });
  
  export const updatePartReplacementDetailsRoutineInspection = (type, details) => ({
    type: "UPDATE_PART_REPLACEMENT_ROUTINE_INSPECTION",
    //"UPDATE_PART_REPLACEMENT_ROUTINE_INSPECTION",
    payload: details,
  });
  
  export const clearPartRepalacementRoutineInspection = (type, details) => ({
    type: type,
    //"CLEAR_PART_REPLACEMENT_ROUTINE_INSPECTION",
    payload: details,
  });
  
  export const costInfoDetailsRoutineInspection = (type, details) => ({
    type: 'CREATE_COST_INFO_ROUTINE_INSPECTION',
    //"CREATE_COST_INFO_ROUTINE_INSPECTION",
    payload: details,
  });
  
  export const assessmentsDetailsRoutineInspection = (type, details) => ({
    type: type,
    //"CREATE_ASSESMENTS_ROUTINE_INSPECTION",
    payload: details,
  });
  
  export const addRepairTrackerDetailsRoutineInspection = (type, details) => ({
    type: type,
    //"ADD_REPAIR_TRACKER_DETAILS_ROUTINE_INSPECTION",
    payload: details,
  });
  
  export const updateRepairTrackerDetailsRoutineInspection = (type, details) => ({
    type: type,
    //"UPDATE_REPAIR_TRACKER_DETAILS_ROUTINE_INSPECTION",
    payload: details,
  });
  
  export const deleteRepairTrackerRoutineInspections = (type, details) => ({
    type: type,
    //"DELETE_REPAIR_TRACKER_ROUTINE_INSPECTION",
    payload: details,
  });
  
  export const clearRepairtrackerRoutineInspection = (type, details) => ({
    type: type,
    //"CLEAR_REPAIRTRACKER_ROUTINE_INSPECTION",
    payload: details,
  });
  
  